import { ref, computed } from 'vue'
import nl from '@/i18n/nl'
import en from '@/i18n/en'

const messages = { nl, en }
const locale = ref('nl')

export function useLocale() {

  function t(key, params) {
    const msg = messages[locale.value]?.[key] ?? messages.nl[key] ?? key
    if (!params) return msg
    return msg.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? `{${k}}`)
  }

  function setLocale(lang, router) {
    locale.value = lang
    localStorage.setItem('mr-lang', lang)
    document.documentElement.lang = lang
    if (router) {
      const current = router.currentRoute.value
      const path = current.path.replace(/^\/en\/?/, '/')
      router.push(lang === 'en' ? `/en${path === '/' ? '' : path}` : path)
    }
  }

  const isEnglish = computed(() => locale.value === 'en')

  return { locale, t, setLocale, isEnglish }
}
